"use client";

import React, { useState, useEffect, useRef, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../utility/cropImage";
import { firestore } from "../../app/firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

export default function TryYourself({ productId, onClose }) {
  const [template, setTemplate] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [finalImage, setFinalImage] = useState(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    const fetchTemplate = async () => {
      const q = query(collection(firestore, "templates"), where("productId", "==", productId));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const data = snap.docs[0].data();

      const parsedTemplate = {
  ...data,
  width: parseInt(data.width),
  height: parseInt(data.height),
  aspectRatio:
    parseFloat(data.aspectRatio.split(":")[0]) /
    parseFloat(data.aspectRatio.split(":")[1]),
  padding: {
    left: parseInt(JSON.parse(data.padding).left),
    top: parseInt(JSON.parse(data.padding).top),
    right: parseInt(JSON.parse(data.padding).right),
    bottom: parseInt(JSON.parse(data.padding).bottom),
  },
};

        setTemplate(parsedTemplate);
      } else {
        console.log("No template found for productId:", productId);
      }
    };

    fetchTemplate();
  }, [productId]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageSrc(URL.createObjectURL(file));
      setFinalImage(null);
    }
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    if (!imageSrc || !croppedAreaPixels || !template) {
      alert("Missing required data. Please upload an image and ensure template is loaded.");
      return;
    }

    try {
      // Get cropped image URL
      const croppedURL = await getCroppedImg(imageSrc, croppedAreaPixels);

      // Load template image via fetch as blob to avoid CORS issues
      const templateImg = new Image();
      templateImg.crossOrigin = "anonymous";

const firebaseFunctionURL = "https://imageproxy-6f3hdg3qaa-uc.a.run.app";


fetch(`${firebaseFunctionURL}?url=${encodeURIComponent(template.image)}`)

  .then(res => res.blob())
  .then(blob => {
    const blobUrl = URL.createObjectURL(blob);
    templateImg.src = blobUrl;
          templateImg.onload = () => {
            // Load cropped image
            const croppedImg = new Image();
            croppedImg.crossOrigin = "anonymous";
            croppedImg.src = croppedURL;

            croppedImg.onload = () => {
              const canvas = canvasRef.current;
              if (!canvas) {
                alert("Canvas not found. Please try again.");
                return;
              }

              const ctx = canvas.getContext("2d");

              // Set canvas size to template size
              canvas.width = template.width;
              canvas.height = template.height;

              // Clear and draw template background
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              ctx.drawImage(templateImg, 0, 0, template.width, template.height);

              // Draw cropped image in frame area using padding
 const { left, top, right, bottom } = template.padding;
const frameX = left;
const frameY = top;
const frameWidth = template.width - left - right;
const frameHeight = template.height - top - bottom;

const imgAspect = croppedImg.width / croppedImg.height;
const frameAspect = frameWidth / frameHeight;

let drawWidth, drawHeight, offsetX, offsetY;

if (imgAspect > frameAspect) {
  // Image is wider than frame, fit height and crop width
  drawHeight = frameHeight;
  drawWidth = imgAspect * drawHeight;
  offsetX = frameX - (drawWidth - frameWidth) / 2;
  offsetY = frameY;
} else {
  // Image is taller or equal aspect, fit width and crop height
  drawWidth = frameWidth;
  drawHeight = drawWidth / imgAspect;
  offsetX = frameX;
  offsetY = frameY - (drawHeight - frameHeight) / 2;
}

ctx.drawImage(croppedImg, offsetX, offsetY, drawWidth, drawHeight);


              // Convert canvas to blob and set final image URL
              canvas.toBlob((blob) => {
                if (blob) {
                  const resultURL = URL.createObjectURL(blob);
                  setFinalImage(resultURL);
                } else {
                  alert("Failed to process final image. Please try again.");
                }
              }, "image/png");
            };

            croppedImg.onerror = () => {
              alert("Failed to load cropped image. Please try again.");
            };
          };

          templateImg.onerror = () => {
            alert("Failed to load template image. Please check the template URL.");
          };
        })
        .catch(err => {
          console.error("Failed to fetch template image as blob:", err);
          alert("Unable to load template image due to CORS. Please check your Firebase Storage settings or use a proxy.");
        });

    } catch (e) {
      alert("An error occurred during image processing: " + e.message);
    }
  }, [imageSrc, croppedAreaPixels, template]);

  if (!template) return <div className="text-white text-center">Loading template...</div>;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-5xl overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Try Your Image on Product</h2>
          <button onClick={onClose} className="text-red-500 font-semibold">Close</button>
        </div>

        <div className="md:flex gap-8">
          {/* Left - Template Display */}
          {/* <div className="md:w-1/2 w-full">
            <h4 className="mb-2 font-medium">Product Template</h4>
            <img
              src={template.image}
              alt="Template Preview"
              className="w-full border rounded-lg"
            />
          </div> */}

          {/* Right - Upload and Crop */}
          <div className="md:w-1/2 w-full">
            <h4 className="mb-2 font-medium">Upload & Crop</h4>
            <input 
              type="file" 
              accept="image/*" 
              onChange={handleImageUpload}
              className="mb-4"
            />
            
            {imageSrc && !finalImage && (
              <div className="relative mt-4 w-full h-64">
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={template.aspectRatio}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
                <button
                  onClick={showCroppedImage}
                  className="absolute bottom-2 left-2 bg-blue-600 text-white px-4 py-1 rounded shadow hover:bg-blue-700 transition-colors"
                >
                  Crop & Insert
                </button>
              </div>
            )}

            {finalImage && (
              <div className="mt-6">
                <h4 className="font-medium mb-2">Final Image:</h4>
                <img 
                  src={finalImage} 
                  alt="Final Output" 
                  className="w-full border rounded-lg"
                  
                />
                {/* <a href={finalImage} download="preview.png">
                  <button className="mt-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors">
                    Download Image
                  </button>
                </a> */}
              </div>
            )}
          </div>
        </div>

        {/* Hidden canvas for image processing */}
        <canvas ref={canvasRef} style={{ display: "none" }} />
      </div>
    </div>
  );
}
